import { render, staticRenderFns } from "./DialogWechatMerchant.vue?vue&type=template&id=4b7c6a73&"
import script from "./DialogWechatMerchant.vue?vue&type=script&lang=js&"
export * from "./DialogWechatMerchant.vue?vue&type=script&lang=js&"
import style0 from "./DialogWechatMerchant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports